import { assignClientVariant } from "../utils/assignClientVariant";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;

export default function getMyUpsolveEntryUrl(fromStudentLoansCTA = false): string {
  if (!UPSOLVE_FILER_URL) {
    return "";
  }

  const isServiceAssessmentEnabled = assignClientVariant("entry_url_variant", 2) === "B";
  const basePath = isServiceAssessmentEnabled ? "/service-assessment/step/intro" : "/bankruptcy-screener";

  const url = new URL(`${UPSOLVE_FILER_URL}${basePath}`);

  if (fromStudentLoansCTA) {
    url.searchParams.set("fromStudentLoansCTA", "true");
  }

  if (typeof window !== "undefined") {
    const currentParams = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach((key) => {
      const val = currentParams.get(key);
      if (val) {
        url.searchParams.set(key, val);
      }
    });
  }

  return url.toString();
}
